import axios from "axios";
import store from "../store";
import { Creators as AuthActions } from "../store/ducks/auth";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true // envia cookies httpOnly automaticamente em todas as requisições
});

// Interceptor de request: não precisa mais injetar tokens manualmente (estão nos cookies)
api.interceptors.request.use(config => config);

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched() {
  subscribers.forEach(callback => callback());
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

function fetchAccessToken() {
  return api.put("/private/token");
}

api.interceptors.response.use(
  function (response) {
    // Tokens são renovados automaticamente pelo servidor via cookies
    // Apenas normaliza o formato de resposta { data }
    if (response.data?.data !== undefined)
      response.data = response.data.data

    return response;
  },
  function (error) {
    const { config, response } = error;

    if (!response) return Promise.reject(error);

    const { status } = response;
    const originalRequest = config;

    if (status === 401) {
      if (!store.getState().auth.signed) {
        return Promise.reject(error);
      }

      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;

        fetchAccessToken()
          .then(() => {
            isAlreadyFetchingAccessToken = false;
            onAccessTokenFetched();
          })
          .catch(() => {
            isAlreadyFetchingAccessToken = false;
            store.dispatch(AuthActions.signOut());
          });
      }

      return new Promise(resolve => {
        addSubscriber(() => resolve(axios({ ...originalRequest, withCredentials: true })));
      });
    }

    return Promise.reject(error);
  }
);

export default api;
